interface TransferNumberParts {
    phoneNumber: string;
    suffix: string;
}

const getTransferNumberParts = (numberStr: string): TransferNumberParts => {
    const numberWithSuffix = numberStr.trim().match(/^([^;]+);(\d+)$/);
    if (!numberWithSuffix) {
        return { phoneNumber: numberStr.includes(';') ? '' : numberStr, suffix: '' };
    }

    return {
        phoneNumber: numberWithSuffix[1],
        suffix: `;${numberWithSuffix[2]}`
    };
};

export const getTransferPhoneDigits = (numberStr: string | null | undefined): string | null => {
    if (!numberStr) return null;

    const { phoneNumber } = getTransferNumberParts(numberStr);
    const cleaned = phoneNumber.replace(/\D/g, '');
    if (cleaned.length === 10 || (cleaned.length === 11 && cleaned.startsWith('1'))) {
        return cleaned;
    }

    return null;
};

export const formatTransferNumber = (numberStr: string | null | undefined): string => {
    if (!numberStr) return 'None';

    const { phoneNumber, suffix } = getTransferNumberParts(numberStr);
    const cleaned = phoneNumber.replace(/\D/g, '');
    if (cleaned.length === 10) {
        return `+1 (${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6)}${suffix}`;
    } else if (cleaned.length === 11 && cleaned.startsWith('1')) {
        return `+1 (${cleaned.substring(1, 4)}) ${cleaned.substring(4, 7)}-${cleaned.substring(7)}${suffix}`;
    }
    return numberStr;
};
